import { NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, effect, input, output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { ConditionProcessorUtil } from '@iot-platform/iot-platform-utils';

import { MasterViewEngineEvent } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'grid-engine-call-to-action-menu-item',
  templateUrl: './call-to-action-menu-item.component.html',
  imports: [FlexLayoutModule, MatDivider, UpperCasePipe, MatMenuItem, TranslatePipe, MatIcon, NgTemplateOutlet, MatIconButton, MatTooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./call-to-action-menu-item.component.scss']
})
export class CallToActionMenuItemComponent {
  element = input<any>();
  action = input<any>();
  userPermissions = input<{ key: string; value: boolean }[]>();

  actionClicked = output<MasterViewEngineEvent>();
  sendIsVisible = output<{ action: any; isVisible: boolean }>();

  isVisible: WritableSignal<boolean> = signal(false);
  isEnabled: WritableSignal<boolean> = signal(false);
  isDisabled: WritableSignal<boolean> = signal(false);

  constructor() {
    effect(() => {
      const element = this.element();
      const action = this.action();
      this.setVisibleAndEnable(element, action);
    });
  }

  onSingleActionClick(actionKey: string): void {
    const element = this.element();
    this.actionClicked.emit({
      type: actionKey,
      options: { elementId: element?.id, actionKey, element },
      rawData: element
    });
  }

  private setVisibleAndEnable(element: any, action: any): void {
    const userPermissions = this.userPermissions();
    if (element && action) {
      const permissionVisible = ConditionProcessorUtil.processConditionsWithPermission(action.visibleConditions, userPermissions);
      const rowVisible = ConditionProcessorUtil.processConditionsWithElement(action.elementVisibleConditions ?? [], element, true, userPermissions);
      const isVisible = permissionVisible && rowVisible;
      this.isVisible.set(isVisible);
      this.isEnabled.set(ConditionProcessorUtil.processConditionsWithElement(action.enableConditions, element, true, userPermissions));
      this.isDisabled.set(ConditionProcessorUtil.processConditionsWithElement(action.disableConditions, element, false, userPermissions));
      this.sendIsVisible.emit({ action, isVisible });
    }
  }
}
